import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-dialogmenuplan',
  templateUrl: './dialogmenuplan.component.html',
  styleUrls: ['./dialogmenuplan.component.css']
})
export class DialogmenuplanComponent implements OnInit {
  @Input() showDialog: Boolean = false;
  @Output() onCloseDialog: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  onclose = (event, valueclick) => {
    this.onCloseDialog.emit({
      status: false,
      event: event,
      statusclick: valueclick
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/shared/components/dialogmenuplan/dialogmenuplan.component.ts